module.exports = __webpack_public_path__ + "img/wx.03d4d996.png";